import { ActionType } from 'typesafe-actions';

import * as actions from '../actions/knmListByPlanActions';
import { KnmListByPlanActionsEnum } from '../enums/KnmListByPlanActionsEnum';
import { IKnmListByPlanFilterWithMeta } from '../interfaces/IKnmListByPlanFilterWithMeta';
import { IKnmListByPlanState } from '../interfaces/IKnmListByPlanState';

export type KnmListByPlanAction = ActionType<typeof actions>;

const initial: IKnmListByPlanState = {
  planId: undefined,
  typeList: undefined,
  data: [],
  order: null,
  page: 0,
  pageCount: 0,
  totalCount: 0,
  searchValue: '',
  isFilterLoading: false,
  current: undefined,
  isFilterOn: false,
  filters: [],
  supervisionTypeDictVersionId: undefined,
};

export function knmListByPlanReducer(state = initial, action: KnmListByPlanAction) {
  switch (action.type) {
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_RESET_PAGE: {
      return initial;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_BASIC_FILTERS: {
      const newState: IKnmListByPlanState = {
        ...state,
        planId: action.payload.planId,
        typeList: action.payload.typeList,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_SEARCH_VALUE: {
      const newState: IKnmListByPlanState = {
        ...state,
        searchValue: action.payload.value,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_DATA: {
      const { data, page, totalCount, pageCount } = action.payload;
      const newState: IKnmListByPlanState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_ORDER: {
      const { order } = action.payload;
      const newState: IKnmListByPlanState = {
        ...state,
        order,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_CURRENT: {
      const { current, currentId } = action.payload;
      const newState: IKnmListByPlanState = {
        ...state,
        current,
        currentId,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_SWITCHER: {
      const { value: isFilterOn } = action.payload;
      const newState: IKnmListByPlanState = {
        ...state,
        isFilterOn,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_LOADING: {
      const newState: IKnmListByPlanState = {
        ...state,
        isFilterLoading: action.payload.value,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_META: {
      const filters = action.payload.list.map<IKnmListByPlanFilterWithMeta>(meta => ({ meta }));
      const newState: IKnmListByPlanState = {
        ...state,
        filters,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_REMOVE: {
      const { id } = action.payload;
      const filters = state.filters.filter(f => f.meta.id !== id);
      const newState: IKnmListByPlanState = {
        ...state,
        filters,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_DATA: {
      const { id, data } = action.payload;
      const filters = state.filters.map<IKnmListByPlanFilterWithMeta>(filter => {
        if (filter.meta.id === id) {
          return {
            ...filter,
            data,
          };
        }

        return filter;
      });
      const newState: IKnmListByPlanState = {
        ...state,
        filters,
      };

      return newState;
    }
    case KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_SUPERVISION_TYPE_DICT_VERSION_ID: {
      return {
        ...state,
        supervisionTypeDictVersionId: action.payload.supervisionTypeDictVersionId,
      };
    }
    default:
      return state;
  }
}
